<template>
  <div class="quiz-container">
    <!-- خلفية زخرفية متحركة خفيفة -->
    <div class="bg-orbs" aria-hidden="true">
      <span class="orb orb-a"></span>
      <span class="orb orb-b"></span>
      <span class="orb orb-c"></span>
    </div>

    <!-- الهيدر -->
    <header class="header">
      <h1 class="title" aria-label="Bacly Plus">
        🎓 MQBank<span class="plus">+</span>
      </h1>
     
    </header>

    <!-- الأزرار -->
    <nav class="buttons" aria-label="خيارات سريعة">


      <button
        @click="$emit('select','T')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
       <span class="label"> تحديد المستوى (PT) - افتراضي </span>
      </button>



      <button
        @click="$emit('select','B')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">اختبار القيد بدرجة ماجستير - افتراضي  </span>
      </button>

      <button
        @click="$emit('select','w')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">  اختبار وطني للغات </span>
      </button>

      <button
        @click="$emit('select','M')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">   تعليم عالي - مقدرة لغوية     </span>
      </button>

      <button
        @click="$emit('select','D')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">   اختبار القيد بدرجة دكتوراه</span>
      </button>

      <a
        href="https://t.me/qeyd_master_english"
        target="_blank"
        rel="noopener"
        class="main-btn btn-telegram"
        aria-label="قناة التلغرام"
      >
        <span class="icon icon-telegram" aria-hidden="true" role="img">
          <svg
            viewBox="0 0 240 240"
            width="22"
            height="22"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
          >
            <defs>
              <linearGradient id="tgGrad" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stop-color="#2AABEE" />
                <stop offset="100%" stop-color="#229ED9" />
              </linearGradient>
            </defs>
            <circle cx="120" cy="120" r="120" fill="url(#tgGrad)" />
            <path
              d="M179 75.4c2.2-1.1 4.6 1.1 3.8 3.4l-25.8 121.4c-.7 3.2-4.5 4.5-7 2.5l-35.3-26.6a5 5 0 0 1-1.8-3.2l-2.9-23.6a5 5 0 0 1 1.5-4.3l58.6-55.4c1.4-1.3-.3-3.6-1.9-2.6l-72.2 45.6a5 5 0 0 1-4.6.3l-31.1-14a3 3 0 0 1 .2-5.5l117.5-48.1z"
              fill="#fff"
            />
          </svg>
        </span>
        <span class="label">قناة التلغرام الرسمية</span>
      </a>

      <router-link
        to="/resources"
        class="main-btn btn-resources"
        aria-label="اسئلة دورات محلولة"
      >
        <span class="icon" aria-hidden="true">🧭</span>
        <span class="label">
             قواعد اللغة الانكليزية<br>
             
        </span>

      </router-link>
    </nav>

    <!-- فوتر صغير -->
    <footer class="footer">
      <span class="badge">Made with ♥ for Students</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BranchSelector'
}
</script>

<style scoped>
/* إعدادات عامة */
.quiz-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding: 3rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;           /* توسيط أفقي */
  justify-content: center;       /* توسيط عمودي */
  gap: 2rem;
  text-align: center;
  color: #eaeaf0;
  background:
    radial-gradient(1200px 800px at 10% 10%, rgba(60, 60, 90, 0.25), transparent 50%),
    radial-gradient(900px 600px at 90% 20%, rgba(0, 120, 255, 0.18), transparent 55%),
    linear-gradient(180deg, #0a0a0f 0%, #0b0d14 50%, #0a0a0f 100%);
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Tajawal", "Inter", system-ui, sans-serif;
}

/* عناصر زخرفية */
.bg-orbs {
  position: absolute;
  inset: 0;
  pointer-events: none;
  filter: blur(40px);
}
.orb {
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  opacity: 0.35;
  mix-blend-mode: screen;
  animation: float 12s ease-in-out infinite;
}
.orb-a { background: #3b82f6; top: 10%; left: 5%; animation-delay: 0s; }
.orb-b { background: #22d3ee; bottom: 15%; right: 8%; animation-delay: 3s; }
.orb-c { background: #a78bfa; top: 55%; left: 65%; animation-delay: 6s; }

@keyframes float {
  0%, 100% { transform: translateY(0) translateX(0) scale(1); }
  50% { transform: translateY(-12px) translateX(6px) scale(1.03); }
}

/* الهيدر */
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .75rem;
  z-index: 1;
  margin-bottom: .25rem;
}
.title {
  margin: 0;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(2.4rem, 6vw, 3.6rem);
  line-height: 1.1;
  background: linear-gradient(90deg, #ffd54a, #ffae00 45%, #ffe680 85%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 16px rgba(255, 206, 72, 0.15);
}
.title .plus {
  margin-inline-start: 2px;
  background: linear-gradient(90deg, #86efac, #22c55e);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.subtitle {
  font-size: clamp(.9rem, 3vw, .98rem);
  text-align: center;
  margin-bottom: 1.4rem;
  line-height: 1.7;
  font-weight: 700; /* خط أثقل ليظهر بوضوح */

  /* تدرج ذهبي */
  background: linear-gradient(
    180deg,
    #f9e7b3 0%,   /* ذهبي فاتح */
    #d4af37 40%,  /* ذهبي متوسط */
    #b8860b 70%,  /* برونزي */
    #7a5c1e 100%  /* ذهبي داكن */
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  /* تأثير محفور */
  text-shadow:
    0 2px 3px rgba(0,0,0,0.65),      /* ظل خارجي */
    0 -1px 1px rgba(255,255,255,0.25), /* لمعة علوية */
    inset 0 2px 4px rgba(0,0,0,0.85);  /* إحساس الحفر */
}

/* مجموعة الأزرار: عمودياً وتوسيط كامل */
.buttons {
  width: 100%;
  max-width: 420px;          /* عرض مريح على الجوال */
  display: flex;
  flex-direction: column;    /* تحت بعضها */
  align-items: stretch;      /* تمتلئ العرض المحدد */
  gap: 1rem;
  z-index: 1;
}

/* زر أساسي بنمط زجاجي */
.main-btn {
  appearance: none;
  border: 0;
  border-radius: 16px;
  padding: 1.1rem 1.1rem;
  background: linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02));
  color: #eef2ff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;     /* توسيط النص والأيقونة */
  gap: .7rem;
  font-weight: 800;
  font-size: 1.1rem;
  letter-spacing: 0.2px;
  backdrop-filter: saturate(130%) blur(8px);
  -webkit-backdrop-filter: saturate(130%) blur(8px);
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.12),
    0 8px 24px rgba(0,0,0,0.45),
    0 2px 8px rgba(0,0,0,0.35);
  outline: none;
  cursor: pointer;
  transition:
    transform .18s ease,
    box-shadow .25s ease,
    background .25s ease,
    color .25s ease,
    border-color .25s ease;
  position: relative;
  overflow: hidden;
}

/* حافة مضيئة خفيفة عند الهوفر/الفوكس */
.main-btn::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 16px;
  pointer-events: none;
  box-shadow: 0 0 0 0 rgba(99,102,241,0);
  transition: box-shadow .25s ease;
}
.main-btn:focus-visible::after,
.main-btn:hover::after {
  box-shadow: 0 0 0 4px rgba(99,102,241,0.22);
}

/* حركة خفيفة */
.main-btn:hover { transform: translateY(-2px); }
.main-btn:active { transform: translateY(0); }

/* محتوى الزر */
.icon {
  font-size: 1.35em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.label {
  line-height: 1;
}

/* تنويعات الأزرار */
.btn-bank {
  background:
    linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02));
  border: 1px solid rgba(147, 197, 253, 0.25);
}

.btn-telegram {
  background: linear-gradient(135deg, #2AABEE, #229ED9);
  color: #ffffff;
  border: 1px solid rgba(255,255,255,0.22);
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.18),
    0 10px 28px rgba(34,158,217,0.45),
    0 2px 10px rgba(34,158,217,0.35);
}
.btn-telegram:hover {
  background: linear-gradient(135deg, #36b7f4, #2aa6e0);
}

.icon-telegram svg {
  display: block;
}

.btn-resources {
  background:
    linear-gradient(180deg, rgba(255, 243, 194, 0.08), rgba(255, 238, 170, 0.02));
  color: #ffeaa7;
  border: 1px solid rgba(255, 224, 138, 0.35);
}
.btn-resources:hover {
  color: #fff6cf;
}

/* فوتر */
.footer {
  z-index: 1;
}
.badge {
  display: inline-block;
  font-size: .8rem;
  color: #9aa3b2;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  padding: .4rem .7rem;
  border-radius: 999px;
  backdrop-filter: blur(6px);
}

/* استجابة الشاشات الضيقة */
@media (max-width: 360px) {
  .main-btn { font-size: 1rem; padding: 1rem 0.9rem; }
  .icon { font-size: 1.25em; }
}

/* تباين وتحسين وصول */
.main-btn:focus-visible {
  outline: none;
}
.main-btn:focus-visible {
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.12),
    0 0 0 3px rgba(99,102,241,0.5),
    0 8px 24px rgba(0,0,0,0.45);
}
</style>